import React from 'react';

const PARTNERS = ['Easy Lease Motor Cycle Rental'];

const Partners: React.FC = () => (
  <section className="partners-section">
    <div className="partners-inner">
      <div className="partners-label">
        <div className="partners-label-eyebrow">Where we work</div>
        <div className="partners-label-title">Top Ranking<br/>Company</div>
      </div>
      <div className="partners-divider" />
      <div className="partners-logos">
        {PARTNERS.map((p, i) => (
          <React.Fragment key={p}>
            <span className="partner-name">{p}</span>
            {i < PARTNERS.length - 1 && <span style={{ color: '#e2e8f0', fontSize: 20 }}>·</span>}
          </React.Fragment>
        ))}
      </div>
    </div>
  </section>
);
export default Partners;
